var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/paper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66699 8.9873C3.66699 5.2605 6.84066 2.34863 10.4457 2.34863H19.3163C19.7701 2.34863 20.2043 2.53369 20.5186 2.86108L27.272 9.89574C27.5699 10.2061 27.7363 10.6197 27.7363 11.05V23.2713C27.7363 26.8359 24.8653 30.1526 21.0977 30.1526H10.4457C6.58232 30.1526 3.66699 27.0497 3.66699 23.2713V8.9873ZM10.4457 5.68197C8.55999 5.68197 7.00033 7.22076 7.00033 8.9873V23.2713C7.00033 25.2956 8.509 26.8193 10.4457 26.8193H21.0977C22.8233 26.8193 24.403 25.2027 24.403 23.2713V11.7205L18.606 5.68197H10.4457ZM9.8501 21.0765C9.8501 20.156 10.5963 19.4098 11.5168 19.4098H18.7128C19.6332 19.4098 20.3794 20.156 20.3794 21.0765C20.3794 21.997 19.6332 22.7432 18.7128 22.7432H11.5168C10.5963 22.7432 9.8501 21.997 9.8501 21.0765ZM11.516 12.807C10.5956 12.807 9.84937 13.5532 9.84937 14.4736C9.84937 15.3941 10.5956 16.1403 11.516 16.1403H15.9907C16.9112 16.1403 17.6574 15.3941 17.6574 14.4736C17.6574 13.5532 16.9112 12.807 15.9907 12.807H11.516Z",
    fill: "#354360"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M18.9658 4V7.87867C18.9658 9.772 20.4978 11.308 22.3898 11.312C24.1458 11.316 25.9418 11.3173 26.0632 11.3093",
    stroke: "#354360",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.f4a0fb2266b3fe663ed92bebacd0a719.svg";
export { ForwardRef as ReactComponent };